module.exports = "/assets/6e9297bb0b88b80f67fda28182fb73c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TU.png
// module id = 1869
// module chunks = 0